@if (!edit) {
  <h1 mat-dialog-title>Thema erstellen</h1>
}
@if (edit) {
  <h1 mat-dialog-title>Thema bearbeiten</h1>
}
<mat-dialog-content class="custom-scrollbar w800">
  <div class="pad-top8">
    <div>
      <form [formGroup]="firstFormGroup">
        <mat-form-field appearance="outline" class="w49 marg-right2">
          <mat-label>Name</mat-label>
          <input formControlName="nameCtrl" matInput placeholder="" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w49">
          <mat-label>Art</mat-label>
          <mat-select formControlName="typeCtrl" placeholder="">
            <mat-option>&mdash;</mat-option>
            @for (option of typeList; track option) {
              <mat-option [value]="option">{{option}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </div>
    <div>
      <form [formGroup]="secondFormGroup">
        <div (click)="openCategorySelectionDialog()" tabindex="0" class="w100">
          <mat-form-field appearance="outline" class="w100">
            <mat-label>Überthema</mat-label>
            <mat-select formControlName="categoryCtrl" multiple placeholder="">
              @for (option of [selectedParentCategory]; track option) {
                <mat-option [value]="option?.id">
                  {{option?.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-raised-button>Abbrechen</button>
  <button (click)="saveOrCreateCategory()" [disabled]="
    firstFormGroup.controls.nameCtrl.hasError('required') ||
    firstFormGroup.controls.typeCtrl.hasError('required')" color="primary"
    mat-raised-button>Speichern
  </button>
</mat-dialog-actions>
